import { useState } from 'react';
import ThemedDialog from "../../../Components/ThemedDialog";
import { confirmable, createConfirmation, ReactConfirmProps } from "react-confirm";
import formatVehicleAssessmentRejectionTopic from "../formatVehicleAssessmentRejectionTopic";
import { VehicleAssessmentRejectionTopic, vehicleAssessmentRejectionTopics } from "../../../system/Domain";
import { Box, Button, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";
import { AttachFile } from "@mui/icons-material";

interface Props extends ReactConfirmProps<any> {
	show: boolean
}

const RejectVehicleAssessmentDialog = (props: Props) => {
	const [topic, setTopic] = useState<VehicleAssessmentRejectionTopic>();
	const [reason, setReason] = useState<string>("");
	const [file, setFile] = useState<File | null>(null);

	const handleClose = () => {
		props.cancel();
	};

	const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setFile(e.target.files && e.target.files.length > 0 ? e.target.files[0] : null);
	};

	return (
		<ThemedDialog
			open={props.show}
			maxWidth="md"
			onClose={handleClose}
		>
			<DialogTitle>
				Gutachten ablehnen
			</DialogTitle>
			<DialogContent>
				<Box mb={4} minWidth="300px">
					<FormControl
						fullWidth
						variant="standard"
					>
						<InputLabel>Ablehnungsgrund</InputLabel>
						<Select
							onChange={(e) => setTopic(e.target.value as VehicleAssessmentRejectionTopic)}
							fullWidth
						>
							{vehicleAssessmentRejectionTopics.map(t => (
								<MenuItem key={t} value={t}>
									{formatVehicleAssessmentRejectionTopic(t)}
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</Box>
				<Box mb={2}>
					<TextField
						fullWidth
						variant="outlined"
						value={reason}
						label="Beschreibung"
						onChange={(e) => setReason(e.target.value)}
					/>
				</Box>
				<Box mb={2}>
					<Button
						variant="outlined"
						component="label"
						startIcon={<AttachFile />}
					>
						{file ? file.name : "Dokument anhängen (optional)"}
						<input
							type="file"
							hidden
							accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx"
							onChange={handleFileChange}
						/>
					</Button>
					{file && (
						<Box mt={1}>
							<Typography variant="caption" color="textSecondary">
								Das Dokument (z.B. KVA/GA) wird zusammen mit der Ablehnung an den Dienstleister übermittelt.
							</Typography>
						</Box>
					)}
				</Box>
			</DialogContent>
			<DialogActions>
				<Button
					variant="outlined"
					color="secondary"
					href=""
					onClick={handleClose}
				>
					Abbrechen
				</Button>
				<Button
					variant="outlined"
					color="primary"
					href=""
					disabled={!topic || !reason}
					onClick={() => props.proceed({
						topic, reason, file
					})}
				>
					Ok
				</Button>
			</DialogActions>
		</ThemedDialog>
	);
};

interface Result {
	reason: string
	topic: VehicleAssessmentRejectionTopic
	file: File | null
}

export default (options: any) => {
	const dialog = confirmable(props => <RejectVehicleAssessmentDialog {...props} {...options} />);
	return createConfirmation<Result>(dialog)();
}
